// import React from "react";
// import { useNavigate } from "react-router-dom";

// export const SideNav = () => {
//   const navigate = useNavigate();
//   const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
//   const [isLoggingOut, setIsLoggingOut] = React.useState(false);

//   const handleLogout = async () => {
//     try {
//       setIsLoggingOut(true);
//       const accessToken = localStorage.getItem("accessToken");

//       if (!accessToken) {
//         navigate("/login");
//         return;
//       }

//       const response = await fetch(`${apiRoot}/api/oauth/logout`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Logout failed");
//       }

//       // Clear auth data
//       localStorage.removeItem("accessToken");
//       localStorage.removeItem("refreshToken");
//       localStorage.removeItem("userRole");
//       localStorage.removeItem("userId");

//       // Navigate to login
//       navigate("/login");
//     } catch (error) {
//       console.error("Logout error:", error);
//     } finally {
//       setIsLoggingOut(false);
//     }
//   };

//   const navItems = [
//     { href: "/notification", label: "Notification" },
//     { href: "/user-management", label: "User Management" },
//     { href: "/project-management", label: "Project Management" },
//     { href: "/features", label: "Home Page" },
//     { href: "/activity-monitor", label: "Monitor Activity" },

//     {
//       href: "#",
//       label: isLoggingOut ? "Signing out..." : "Sign out",
//       onClick: handleLogout,
//     },
//   ];

//   return (
//     <nav className="fixed left-0 top-16 bottom-0 w-64 bg-gray-800 text-white p-4">
//       <div className="space-y-2">
//         {navItems.map((item) => (
//           <a
//             key={item.href}
//             href={item.href}
//             onClick={(e) => {
//               if (item.onClick) {
//                 e.preventDefault();
//                 item.onClick();
//               }
//             }}
//             className={`block px-4 py-2 text-gray-200 hover:bg-gray-700 rounded transition-colors ${
//               isLoggingOut && item.label.includes("Sign")
//                 ? "opacity-50 cursor-not-allowed"
//                 : ""
//             }`}
//           >
//             {item.label}
//           </a>
//         ))}
//       </div>
//     </nav>
//   );
// };

// export default SideNav;
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { 
  Bell, 
  Users, 
  FolderOpen, 
  Home, 
  Activity, 
  LogOut,
  Loader,
  ChevronRight
} from "lucide-react";

export const SideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        navigate("/login");
        return;
      }

      const response = await fetch(`${apiRoot}/api/oauth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Logout failed");
      }

      // Clear auth data
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userId");

      // Navigate to login
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const navItems = [
    { 
      href: "/notification", 
      label: "Notifications", 
      icon: Bell,
      gradient: "from-blue-500 to-cyan-500"
    },
    { 
      href: "/user-management", 
      label: "User Management", 
      icon: Users,
      gradient: "from-indigo-500 to-purple-500"
    },
    { 
      href: "/project-management", 
      label: "Project Management", 
      icon: FolderOpen,
      gradient: "from-purple-500 to-pink-500"
    },
    { 
      href: "/features", 
      label: "Home Page", 
      icon: Home,
      gradient: "from-green-500 to-emerald-500"
    },
    { 
      href: "/activity-monitor", 
      label: "Monitor Activity", 
      icon: Activity,
      gradient: "from-orange-500 to-red-500"
    },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <nav className="fixed left-0 top-16 bottom-0 w-64 bg-gradient-to-b from-slate-800 via-slate-900 to-slate-800 text-white overflow-y-auto shadow-2xl border-r border-slate-700/50">
      <div className="p-6">
        {/* Navigation Header */}
        <div className="mb-8">
          <h2 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4">
            Navigation
          </h2>
        </div>

        {/* Navigation Items */}
        <div className="space-y-2 mb-8">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.href);
            
            return (
              <a
                key={item.href}
                href={item.href}
                className={`group flex items-center justify-between p-4 rounded-xl transition-all duration-200 ${
                  active 
                    ? 'bg-gradient-to-r from-blue-600/20 to-indigo-600/20 border border-blue-500/30 shadow-lg' 
                    : 'hover:bg-white/5 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className={`p-2 rounded-lg bg-gradient-to-r ${item.gradient} ${
                    active ? 'shadow-lg' : 'opacity-80 group-hover:opacity-100'
                  } transition-all duration-200`}>
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <span className={`font-medium ${
                    active ? 'text-white' : 'text-slate-300 group-hover:text-white'
                  } transition-colors duration-200`}>
                    {item.label}
                  </span>
                </div>
                <ChevronRight className={`w-4 h-4 ${
                  active ? 'text-blue-400' : 'text-slate-500 group-hover:text-slate-300'
                } transition-all duration-200 ${
                  active ? 'translate-x-1' : 'group-hover:translate-x-1'
                }`} />
              </a>
            );
          })}
        </div>

        {/* Logout Section */}
        <div className="border-t border-slate-700/50 pt-6">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4">
            Account
          </h3>
          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="group w-full flex items-center justify-between p-4 rounded-xl hover:bg-red-600/10 hover:border-red-500/30 border border-transparent transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="flex items-center gap-4">
              <div className="p-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500 group-hover:shadow-lg transition-all duration-200">
                {isLoggingOut ? (
                  <Loader className="w-4 h-4 text-white animate-spin" />
                ) : (
                  <LogOut className="w-4 h-4 text-white" />
                )}
              </div>
              <span className="font-medium text-slate-300 group-hover:text-white transition-colors duration-200">
                {isLoggingOut ? "Signing out..." : "Sign out"}
              </span>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-500 group-hover:text-slate-300 group-hover:translate-x-1 transition-all duration-200" />
          </button>
        </div>
      </div>
    </nav>
  );
};